import BasicModal from "@/modules/common/components/modals/basic-modal";
import { Box, CircularProgress, Stack, useTheme } from "@mui/material";
import { useContext, useState } from "react";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import ModalHeader from "@/modules/common/components/modals/modal-header";
import { HistoryCard } from "@/modules/lead-page/components/lead-history/history-card";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { useQuery } from "@tanstack/react-query";
import { getLeadHistory } from "@/modules/lead-page/api/lead-page.v2.api";
import { queryCommonFlags } from "@/api/constants";
import { LeadHistoryItem } from "@/modules/lead-page/dtos/index-v2";
import { NwButton } from "@nawy/ui";

const LeadHistory = () => {
  const [open, setOpen] = useState(false);
  const { lead } = useContext(LeadPageContext);
  const screen = useScreenSize();

  const theme = useTheme();

  const getEntityUIds = () => {
    const entityUIds = [];
    if (lead?.data?.lead?.oldId) {
      entityUIds.push(lead?.data?.lead?.oldId);
    }
    entityUIds.push(lead?.data?.lead?.uid);
    entityUIds.push(lead?.data?.lead?.journey_uid);
    entityUIds.push(lead?.data?.lead?.customer_uid);
    return entityUIds;
  };

  const leadHistoryParams = {
    system: "crm",
    table: ["lead", "journeys", "customers"],
    entityUId: getEntityUIds(),
  };

  const { data: leadHistoryData } = useQuery(
    ["getLeadHistory"],
    () => getLeadHistory(leadHistoryParams),
    {
      ...queryCommonFlags,
      refetchOnWindowFocus: false,
    }
  );

  const leadHistory = leadHistoryData?.data as LeadHistoryItem[];

  return (
    <>
      <BasicModal
        width={screen.isTablet ? 600 : 800}
        open={open}
        setOpen={setOpen}
        fullScreenMobile
      >
        <Box
          sx={{
            minHeight: "calc(90% - 32px)",
            width: "100%",
            padding: theme.nawy.spacing.xl,
          }}
        >
          <ModalHeader
            headerText="Lead History"
            handleClose={() => setOpen(false)}
          />
          {leadHistory && leadHistory.length > 0 ? (
            leadHistory.map((item: LeadHistoryItem) => (
              <Box
                sx={{
                  paddingBottom: theme.nawy.spacing.xl,
                }}
                key={item._id}
              >
                <HistoryCard item={item} />
              </Box>
            ))
          ) : leadHistory && leadHistory.length === 0 ? (
            <Box
              sx={{
                width: "100%",
                padding: theme.nawy.spacing["3xl"],
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              No lead history to show
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </Box>
      </BasicModal>

      <Stack direction="row" paddingX={theme.nawy.spacing.xs}>
        <NwButton
          sx={{
            minWidth: "fit-content",
            width: "fit-content",
            paddingX: "0px",
          }}
          variant="text"
          onClick={() => setOpen(true)}
        >
          Lead History
        </NwButton>
      </Stack>
    </>
  );
};

export default LeadHistory;
